// TabTitel.jsx — Name des Browser-Tabs je Seite (Aufgabe 154, 02.10.2026)
//
// Bis dahin hieß jedes Fenster „TDA Turniersoftware – …“. Am Turniertag sind
// Aufruf, Leinwand, Schreiber und Dashboard gleichzeitig offen; welcher Tab
// welcher ist, war nicht zu erkennen. Feste Seiten über TITEL, das Dashboard
// über den Bereich in der Adresse (/dashboard/einwaage → „Einwaage“).
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MARKE = 'TDA Events';

// Präfix → Titel; das längste passende Präfix gewinnt
const TITEL = {
  '/formen-display': 'Leinwand Formen',
  '/formen-schreiber': 'Schreiber Formen',
  '/sv-schreiber': 'Schreiber Selbstverteidigung',
  '/siegerehrung-display': 'Leinwand Siegerehrung',
  '/winner-display': 'Leinwand Sieger',
  '/rumble-sieger-display': 'Leinwand Rumble',
  '/bruchtest-display': 'Leinwand Bruchtest',
  '/kampfrichter-display': 'Kampfrichter-Einteilung',
  '/aufruf-control': 'Aufruf-Steuerung',
  '/leitstelle': 'Leitstelle',
  '/turniertag': 'Turniertag vorbereiten',
  '/aufruf': 'Aufruf',
  '/ansage': 'Ansage',
  '/display': 'Mattenanzeige',
  '/judge': 'Kampfrichter',
  '/einwaage-staff': 'Waage',
  '/einwaage-login': 'Waage · Anmeldung',
  '/staff': 'Personal',
  '/staff-login': 'Personal · Anmeldung',
  '/live': 'Live-Ergebnisse',
  '/zuschauer': 'Live · Zuschauer',
  '/ranking': 'Rangliste',
  '/turniere': 'Turniere',
  '/login': 'Anmeldung',
  '/anmelden': 'Anmelden',
  '/register': 'Registrieren',
  '/registrieren': 'Registrieren',
  '/verein': 'Vereinsbereich',
  '/athlete': 'Athletenbereich',
  '/profil': 'Profil',
};

function bereichAusDashboard(pfad) {
  const teil = pfad.replace(/^\/dashboard\/?/, '').split('/')[0];
  if (!teil || teil === 'overview') return 'Dashboard';
  const lesbar = decodeURIComponent(teil).replace(/-/g, ' ');
  return lesbar.charAt(0).toUpperCase() + lesbar.slice(1);
}

export default function TabTitel() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Seiten, die selbst einen Titel setzen (z. B. Camp-Anmeldung), überschreiben danach
    if (pathname === '/') return;
    let titel = null;
    if (pathname.startsWith('/dashboard')) titel = bereichAusDashboard(pathname);
    else {
      const treffer = Object.keys(TITEL).filter((p) => pathname === p || pathname.startsWith(p + '/'))
        .sort((a, b) => b.length - a.length)[0];
      if (treffer) titel = TITEL[treffer];
    }
    if (titel) document.title = `${titel} · ${MARKE}`;
  }, [pathname]);
  return null;
}
